import { useCallback, useRef } from 'react';

interface UseMobileProductsHandoffArgs {
  closeMobileMenu: () => void;
  openProductsMenu: () => void;
}

/**
 * Sequences the mobile-drawer → products-slide-menu handoff so the two drawers
 * never overlap. Tapping "Shop Products" in the mobile nav drawer records a
 * pending intent and closes the mobile drawer only; the products menu opens
 * from the drawer's `afterLeave` (once the 75ms leave transition completes).
 * Closing the drawer any other way (X / overlay) leaves no pending intent, so
 * `onMobileDrawerAfterLeave` is a no-op.
 */
const useMobileProductsHandoff = ({ closeMobileMenu, openProductsMenu }: UseMobileProductsHandoffArgs) => {
  const pendingRef = useRef(false);

  const requestProductsFromMobile = useCallback(() => {
    pendingRef.current = true;
    closeMobileMenu();
  }, [closeMobileMenu]);

  const onMobileDrawerAfterLeave = useCallback(() => {
    if (!pendingRef.current) return;
    pendingRef.current = false;
    openProductsMenu();
  }, [openProductsMenu]);

  return { requestProductsFromMobile, onMobileDrawerAfterLeave };
};

export default useMobileProductsHandoff;
